import React from 'react';
import { Link } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import moment from 'moment';
import _ from 'lodash';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ModalRoot from 'components/Modal/ModalRoot';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Switch from '@material-ui/core/Switch';

import MaterialTable, { MTableToolbar } from 'material-table';

import { Edit, Delete } from '@material-ui/icons';
import { MdRemoveRedEye } from 'react-icons/md';

import {
  RenderIconButton,
  RenderIconButtonRedirect,
} from '../../shared/components/GenericComponents';

import { UrlBox } from '../../shared';
import LeagueTeamSorting from 'templates/common/LeagueTeamSorting';
import { backLink } from 'utils';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
  },
  title: {
    ...theme.Typography,
    color: '#044591',
    margin: '0 10px 0 0',
  },
  btnBack: {
    margin: '0 0 10px 0',
  },
  btnNewEvent: {
    margin: '0 0 20px 20px',
  },
  columnsStyle: '4px 15px 4px 15px',
  tableChannels: {
    marginBottom: '10px',
    width: '100%',
    minWidth: '550px',
  },
  tableSearch: { float: 'right' },
});

class Events extends React.Component {
  renderTableEvents() {
    const {
      classes,
      channelId,
      channelName,
      eventList,
      eventMyVersusList,
      pageSize,
      showClosedEvents,
      updateShowClosed,
      confirmDelete,
      selectedTab,
      leagueSelected,
      teamSelected,
      changeFilter,
    } = this.props;

    let title = 'Events';
    let list = eventList;

    if (selectedTab === 1) {
      title = 'My Versus Demo';
      list = eventMyVersusList;
    }

    const columnActive = {
      title: 'Current my versus',
      field: 'activeMyVersusDemo',
      render: rowData => (
        <div>
          <Switch
            color="primary"
            checked={Boolean(rowData.activeMyVersusDemo)}
            onChange={() =>
              this.props.updateMyVersusDemo(rowData._id, !rowData.activeMyVersusDemo)
            }
          />
        </div>
      ),
      sorting: false,
    };

    const columnElements = [
      {
        cellStyle: { padding: classes.columnsStyle },
        headerStyle: { padding: classes.columnsStyle },
        title: 'Name',
        field: 'name',
        customSort: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
      },
      {
        cellStyle: { padding: classes.columnsStyle },
        headerStyle: { padding: classes.columnsStyle },
        title: 'Start Date',
        field: 'startDate',
        render: rowData => <div>{moment(rowData.startDate).format('ll')}</div>,
        type: 'date',
      },
      {
        cellStyle: { padding: classes.columnsStyle },
        headerStyle: { padding: classes.columnsStyle },
        title: 'State',
        field: 'active',
        render: rowData => (
          <div>
            {rowData.active ? (
              'Active'
            ) : (
              <React.Fragment>
                <div>{'Closed on'}</div>
                <div>{moment(rowData.endDate).format('ll')}</div>
              </React.Fragment>
            )}
          </div>
        ),
        customSort: (a, b) => new Date(a.endDate) - new Date(b.endDate),
      },
      {
        cellStyle: { padding: classes.columnsStyle },
        headerStyle: { padding: classes.columnsStyle },
        title: 'Host',
        field: 'host',
        render: rowData => (
          <div>
            {!_.isEmpty(rowData.host) && rowData.host.fullname
              ? rowData.host.fullname
              : 'None Selected'}
          </div>
        ),
      },
      {
        cellStyle: { padding: classes.columnsStyle },
        headerStyle: { padding: classes.columnsStyle },
        title: 'Options',
        render: row => (
          <div>
            <RenderIconButton
              disabled={row.hasDependencies ? true : false}
              clickEvent={() => {
                confirmDelete(row);
              }}
              title={'Click to delete Event'}
              placement={'top'}
              icon={<Delete />}
              color={'primary'}
            />
            <RenderIconButtonRedirect
              disabled={!row.active}
              redirectEvent={{
                pathname: `/dashboard/channel/admin/eventEditor`,
                state: {
                  channelId: channelId,
                  channelName: channelName,
                  event: row,
                  myVersusDemo: selectedTab === 1,
                },
              }}
              title={'Click to edit this Event'}
              placement={'top'}
              component={Link}
              color={'primary'}
              icon={<Edit />}
            />

            <RenderIconButtonRedirect
              redirectEvent={{
                pathname: `/dashboard/channel/admin/adminEvent`,
                state: {
                  id: row._id,
                },
              }}
              title={'Click to Overview this Event'}
              placement={'top'}
              component={Link}
              color={'primary'}
              icon={<MdRemoveRedEye />}
            />
          </div>
        ),
        sorting: false,
      },
    ];

    if (selectedTab === 1) {
      columnElements.push(columnActive);
    }

    return (
      <div className={classes.tableChannels}>
        <MaterialTable
          elevation={0}
          xs={12}
          options={{
            pageSizeOptions: [5, 10, 20],
            pageSize: pageSize,
            toolbar: true,
            paging: true,
            emptyRowsWhenPaging: false,
          }}
          columns={columnElements}
          data={list}
          title={title}
          components={{
            Toolbar: props => (
              <div>
                <MTableToolbar className={classes.tableSearch} {...props} />

                {selectedTab === 0 && (
                  <div
                    style={{
                      margin: '0px',
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={{ margin: 15 }}>
                      <LeagueTeamSorting
                        league={leagueSelected}
                        query={JSON.stringify({ active: true })}
                        changeLeague={league => changeFilter({ league })}
                        team={teamSelected}
                        changeTeam={(team, clear) =>
                          clear ? null : changeFilter({ team })
                        }
                      />
                    </div>

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={showClosedEvents}
                          onChange={() => {
                            updateShowClosed(showClosedEvents);
                          }}
                          color="primary"
                        />
                      }
                      label="Show closed Events"
                    />
                  </div>
                )}
              </div>
            ),
          }}
        />
      </div>
    );
  }

  render() {
    const { classes, channelId, channelName, selectedTab, onChangeTab } = this.props;

    const nameButton = selectedTab === 0 ? 'create new Event' : 'create my versus demo';

    return (
      <div className={classes.root}>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item xs={6}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography className={classes.title} variant="h6" gutterBottom>
                {`Channel: ${channelName}`}
              </Typography>
              <UrlBox title="Channel Menu Links" path={`/webapp/menu/${channelId}`} />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'baseline',
              }}
            >
              <Button
                className={classes.btnBack}
                variant="text"
                color="default"
                component={Link}
                to={backLink(this.props)}
              >
                BACK
              </Button>
              <Button
                className={classes.btnNewEvent}
                variant="contained"
                size="small"
                color="primary"
                component={Link}
                to={{
                  pathname: '/dashboard/channel/admin/eventEditor',
                  state: {
                    channelId: channelId,
                    channelName: channelName,
                    myVersusDemo: selectedTab === 1,
                  },
                }}
              >
                {nameButton}
              </Button>
            </div>
          </Grid>
        </Grid>
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={selectedTab}
          onChange={onChangeTab}
        >
          <Tab label="Events" />
          <Tab label="My Versus demo" />
        </Tabs>
        {this.renderTableEvents()}
        <ModalRoot />
      </div>
    );
  }
}

export default withStyles(styles)(Events);
